import { Stack } from "@mui/material";
import { RowSkeletonLoader } from "web_myplann/Shared/RowSkeletonLoader";

export const DetailSectionLoader = () => {
	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			sx={{
				height: "100%",
				position: "absolute",
				top: "50%",
				left: "50%",
				transform: "translate(-50%, -50%)",
			}}
			spacing={2}
			px={5}
		>
			<RowSkeletonLoader delay={0} />
			<RowSkeletonLoader delay={200} />
			<RowSkeletonLoader delay={400} />
		</Stack>
	);
};
